import classNames from 'clsx/lite';
import { FC } from 'react';

interface SummaryTableTotalRowProps {
  label: string;
  total?: string;
  isGreen?: boolean;
  isBold?: boolean;
  changingPlan: boolean;
}

const SummaryTableTotalRow: FC<SummaryTableTotalRowProps> = ({
  label,
  total,
  isGreen = false,
  isBold = false,
  changingPlan,
}) => (
  <tr className="SummaryTable__row">
    <td
      colSpan={changingPlan ? 4 : 3}
      className={classNames(
        'SummaryTable__cell',
        'SummaryTable__cell--total-label',
        isBold && 'SummaryTable__cell--bold'
      )}
    >
      {label}
    </td>
    <td
      className={classNames(
        'SummaryTable__cell',
        'SummaryTable__cell--total',
        isBold && 'SummaryTable__cell--bold',
        isGreen && 'SummaryTable__cell--green'
      )}
    >
      {total}
    </td>
  </tr>
);

export default SummaryTableTotalRow;
